/* @flow */
import { List, Map, Record } from 'immutable';
import { isMapLike, isListLike } from 'trustar/utils';

import { createEnclave } from '../enclave/types.js';
import type { Role } from 'modules/roles/types.js';

export const PROFILE_ENDPOINT = '/services/users/profile';
export const PROFILE_QUOTAS_ENDPOINT = '/services/users/profile/quota';
export const PREFERENCES_ENDPOINT = '/services/users/preferences';

export const Profile = Record({
  id: null,
  firstName: '',
  lastName: '',
  email: '',
  guid: '',
  company: null,
  lastLogin: null,
  activationDate: null,
  created: null,
  mfaEnabled: false,
  ssoEnabled: false,
  role: null,
  enclaves: [],
  sector: '',
  preferences: {},
});

export const toProfile = (k: string, v: any) => {
  if (k === '') {
    return Profile(v);
  } else if (k === 'enclaves') {
    return v ? v.map(createEnclave) : v;
  } else if (isMapLike(v)) {
    return Map(v);
  } else if (isListLike(v)) {
    return List(v);
  } else {
    return v;
  }
};

export type RawProfile = {
  id: number,
  firstName: string,
  lastName: string,
  email: string,
  guid: string,
  company: {
    id: number,
    enclaves: Object[],
    name: string,
    sector: { name: string, label: string },
    maxUserCount: number,
  },
  lastLogin: number,
  activationDate: number,
  created: number,
  mfaEnabled: boolean,
  ssoEnabled: boolean,
  role: Role,
  enclaves: Object[],
  sector: string,
  preferences: Object,
};



// WEBPACK FOOTER //
// ./src/app/modules/profile/types.js